import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fileDownload from "js-file-download";
import Button from "../../../components/Button";
import ComboBoxDynamic from "../../../components/ComboBoxDynamic";
import DataTable from "../../../components/DataTable/DataTable";
import Select from "../../../components/Inputs/Select";
import {
  convertNumberToFrontend,
  convertAmountToFrontend,
} from "../../../helpers/convert";
import {
  getObjectionsRequested,
  getObjectionsHistoryRequested,
  setObjectionsFilter,
  setObjectionsHistoryFilter,
  setObjectionsFilterOrganization,
  setObjectionsHistoryFilterOrganization,
} from "../../../redux/actions/objections";
import Pill from "../../../components/Pill";
import MatchHistory from "../../../components/MatchHistory";
import Modal from "../../../components/Modal/Modal";
import TitleValue from "../../../components/TitleValue/TitleValue";
import Icon from "../../../components/Icon";
import Textarea from "../../../components/Inputs/Textarea";
import { setNotification } from "../../../helpers/notification";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import { API_GET, API_PUT, API_EXPORT } from "../../../helpers/api";
import { objectionStatus } from "../../../constants/translations";
import Input from "../../../components/Inputs/Input";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";
import moment from "moment";

export default function Objections({ t }) {
  const dispatch = useDispatch();
  const [exportLoading, setExportLoading] = useState(false);

  const objections = useSelector((state) => state.objections.objections);

  const objectionsFilter = useSelector(
    (state) => state.objections.objectionsFilter
  );

  const { data: objectionsHistory, total: objectTotal } = useSelector(
    (state) => state.objections.objectionsHistory
  );

  const objectionsHistoryFilter = useSelector(
    (state) => state.objections.objectionsHistoryFilter
  );
  const [inspectedObjection, setInspectedObjection] = useState();
  const [objectionJudgeModal, setObjectionJudgeModal] = useState(false);
  const [objectionAnswer, setObjectionAnswer] = useState({
    answer: "",
    objectionStatus: "INITIAL",
  });
  const [contractsFilterList, setContractsFilterList] = useState([]);
  const [objectionApproveModal, setObjectionApproveModal] = useState(false);
  const [objectionAnswerLoading, setObjectionAnswerLoading] = useState(false);
  const [inspectedObjectionDetail, setInspectedObjectionDetail] = useState();

  const [objectionDetailModal, setObjectionDetailModal] = useState(false);
  const [inspectedObjectionHistoryDetail, setInspectedObjectionHistoryDetail] =
    useState();

  const [objectionHistoryDetailModal, setObjectionHistoryDetailModal] =
    useState(false);
  const [activePage, setActivePage] = useState(0);
  const [sortedColumn, setSortedColumn] = useState("productionPeriod");
  const [sortDirection, setSortDirection] = useState("desc");
  const translations = objectionStatus(t);

  const objectionStatusHandler = {
    INITIAL: {
      text: translations.INITIAL,
      color: "primary",
    },
    ACCEPTED: {
      text: translations.ACCEPTED,
      color: "success",
    },
    REJECTED: {
      text: translations.REJECTED,
      color: "important",
    },
  };

  const objectionsColumns = [
    {
      name: t("pages.default.objections.organizationName"),
      selector: "organizationName",
      sortable: true,
    },
    {
      name: t("pages.default.objections.contractName"),
      selector: "contractName",
      sortable: true,
    },
    {
      name: t("pages.default.objections.matchTime"),
      selector: "matchTime",
      sortable: true,
    },
    {
      name: t("pages.default.objections.orderId"),
      selector: "orderId",
      sortable: true,
    },
    {
      name: t("pages.default.objections.offerAmount"),
      selector: "orderAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.orderAmount);
      },
    },
    {
      name: t("pages.default.objections.matchPrice"),
      selector: "matchPrice",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.matchPrice, digit: 2 });
      },
    },
    {
      name: t("pages.default.objections.matchAmount"),
      selector: "orderTotalBuyAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.orderTotalBuyAmount);
      },
    },
    {
      name: t("pages.default.objections.orderType"),
      selector: "orderType",
      sortable: true,
      cell: (row) => {
        return objectionStatus(t)[row.orderType];
      },
    },
    {
      name: t("pages.default.objections.process"),
      selector: "id",
      sortable: false,
      width: "180px",
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              title={t("ui.default.review")}
              type="primary"
              suffixIcon="search"
              onClick={() => toggleObjectionHistoryDetail(row)}
            />
            <Button
              title={t("pages.default.objections.evaluate")}
              type="destructive"
              label={t("pages.default.objections.evaluate")}
              onClick={() => judgeObjection(row)}
            />
          </div>
        );
      },
    },
  ];

  const objectionsHistoryColumns = [
    {
      name: t("pages.default.objections.organizationName"),
      selector: "organizationName",
      sortable: true,
    },
    {
      name: t("pages.default.objections.contractName"),
      selector: "contractName",
      sortable: true,
    },
    {
      name: t("pages.default.objections.orderId"),
      selector: "orderId",
      sortable: true,
    },
    {
      name: t("pages.default.objections.objectionTime"),
      selector: "objectionTime",
      sortable: true,
    },
    {
      name: t("pages.default.objections.objectionDescription"),
      selector: "objectionDescription",
      sortable: true,
    },
    {
      name: t("pages.default.objections.answer"),
      selector: "answer",
      sortable: true,
    },
    {
      name: t("pages.default.objections.statusText"),
      selector: "status",
      sortable: true,
      cell: (row) => {
        return (
          <Pill
            type={objectionStatusHandler[row.status].color}
            label={objectionStatusHandler[row.status].text}
          />
        );
      },
    },
    {
      name: t("pages.default.objections.process"),
      selector: "id",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              title={t("ui.default.review")}
              type="primary"
              suffixIcon="search"
              onClick={() => toggleObjectionDetail(row)}
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getObjections();
    getObjectionsHistory();
    getContracts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getObjections();
      getObjectionsHistory();
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectionsHistoryFilter, objectionsFilter]);

  const getContracts = async () => {
    let res = await API_GET("system-parameter/contract/all");
    let contracts = res.data.reduce(
      (acc, value) => {
        acc.push({
          value: value.id,
          name: value.contractName,
        });
        return acc;
      },
      [{ value: "-", name: t("pages.default.objections.allContracts") }]
    );
    setContractsFilterList(contracts);
  };
  // trigger get requests
  const getObjections = () => {
    dispatch(getObjectionsRequested(objectionsFilter));
  };
  const getObjectionsHistory = () => {
    dispatch(getObjectionsHistoryRequested(objectionsHistoryFilter));
  };

  const toggleObjectionHistoryDetail = (row) => {
    setInspectedObjectionHistoryDetail(row);
    setObjectionHistoryDetailModal(true);
  };

  const toggleObjectionDetail = (row) => {
    setInspectedObjectionDetail(row);
    setObjectionDetailModal(true);
  };

  const judgeObjection = (row) => {
    setInspectedObjection(row);
    setObjectionJudgeModal(true);
  };

  const judgeObjectionValidate = () => {
    if (!objectionAnswer.answer) {
      setNotification(
        "error",
        t("pages.default.objections.errors.answerEmpty")
      );
      return;
    }
    if (objectionAnswer.answer.length < 10) {
      setNotification(
        "error",
        t("pages.default.objections.errors.answerMinCharacter")
      );
      return;
    }
    if (objectionAnswer.objectionStatus === "INITIAL") {
      setNotification("error", t("pages.default.objections.errors.status"));
      return;
    }
    setObjectionApproveModal(true);
  };

  const objectionAnswerRequest = async () => {
    setObjectionAnswerLoading(true);
    try {
      await API_PUT(`objections/${inspectedObjection.id}`, {
        ...objectionAnswer,
        note: inspectedObjection.details.note,
      });
      getObjections();
      getObjectionsHistory();
      setObjectionJudgeModal(false);
      setObjectionApproveModal(false);
      setObjectionAnswerLoading(false);
      setObjectionAnswer({ answer: "", objectionStatus: "INITIAL" });
      setNotification(
        "success",
        t("pages.default.objections.success.evaulation")
      );
    } catch (err) {
      setNotification("error", err.response.data.message);
      setObjectionAnswerLoading(false);
    }
  };

  const objectionAnswerChange = (e) => {
    setObjectionAnswer({ ...objectionAnswer, [e.target.name]: e.target.value });
  };

  const closeObjectionHistoryDetailModal = () => {
    setObjectionHistoryDetailModal(false);
    setInspectedObjectionHistoryDetail();
  };

  const closeObjectionDetailModal = () => {
    setObjectionDetailModal(false);
    setInspectedObjectionDetail();
  };

  const closeObjectionJudgeModal = () => {
    setObjectionJudgeModal(false);
    setInspectedObjection();
    setObjectionAnswer({ answer: "", objectionStatus: "INITIAL" });
  };

  // filters
  const contractChange = (e) => {
    dispatch(setObjectionsFilter({ type: "contract", value: e.target.value }));
  };
  const typeChange = (e) => {
    dispatch(setObjectionsFilter({ type: "type", value: e.target.value }));
  };
  const startDateChange = (e) => {
    console.log(e.target.value);
    dispatch(
      setObjectionsHistoryFilter({ type: "startDate", value: e.target.value })
    );
  };
  const endDateChange = (e) => {
    dispatch(
      setObjectionsHistoryFilter({ type: "endDate", value: e.target.value })
    );
  };
  const statusChange = (e) => {
    dispatch(
      setObjectionsHistoryFilter({ type: "status", value: e.target.value })
    );
  };

  const downloadCommitmentStatus = async () => {
    setExportLoading(true);
    try {
      const res = await API_EXPORT("/objection-admin/export/excel", {
        organizationId: objectionsHistoryFilter?.organization
          ? objectionsHistoryFilter?.organization?.organizationId
          : null,
        objectionStatus:
          objectionsHistoryFilter?.status === "-"
            ? ""
            : objectionsHistoryFilter?.status,
        startDate:
          moment(objectionsHistoryFilter?.startDate).format("YYYYMMDD") ?? null,
        endDate:
          moment(objectionsHistoryFilter?.endDate).format("YYYYMMDD") ?? null,
        lang: window.localStorage.i18nextLng,
      });
      const [, filename] =
        res?.headers["content-disposition"].split("filename=");
      fileDownload(res.data, filename);
      setExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setExportLoading(false);
    }
  };

  const handleClick = (activePage, selector, direction) => {
    console.log("page", activePage, selector, direction);
    setActivePage(activePage);
    dispatch(
      dispatch(
        getObjectionsHistoryRequested({
          status: objectionAnswer?.objectionStatus,
          page: activePage,
          selector,
          direction,
        })
      )
    );
  };
  return (
    <>
      <h5 className="km__u--text-has-emphasis">
        {t("pages.default.objections.objection")}
      </h5>

      <div className="km__p--card">
        <div className="km__p--objections-filter-container">
          <div className="km__p--objections-title">
            {t("pages.default.objections.matches")}
          </div>
          <div className="km__p--objections-filters">
            <ComboBoxDynamic
              t={t}
              selectedOrganization={objectionsFilter.organization}
              organizationSelect={setObjectionsFilterOrganization}
              inputPlaceholder={t(
                "pages.default.certificates.table.organizationName"
              )}
            />
            <Select options={contractsFilterList} onChange={contractChange} />
            <Select
              options={[
                {
                  value: "-",
                  name: t(
                    "pages.default.operationHistory.filters.allOperationTypes"
                  ),
                },
                { value: "BUY", name: t("pages.default.homepage.table.ALIS") },
                {
                  value: "SELL",
                  name: t("pages.default.homepage.table.SATIS"),
                },
              ]}
              onChange={typeChange}
            />
            <Button
              type="primary"
              label={t("ui.default.filter")}
              onClick={getObjections}
            />
          </div>
        </div>
        <DataTable
          columns={objectionsColumns}
          data={objections}
          pagination
          paginationPerPage={15}
        />
      </div>

      <div className="km__p--card">
        <div className="km__p--objections-filter-container">
          <div className="km__p--objections-title">
            {t("pages.default.objections.title")}
          </div>
          <div className="km__p--objections-filters">
            <ComboBoxDynamic
              t={t}
              selectedOrganization={objectionsHistoryFilter.organization}
              organizationSelect={setObjectionsHistoryFilterOrganization}
              inputPlaceholder={t(
                "pages.default.certificates.table.organizationName"
              )}
            />
            <Input
              type="date"
              placeholder={t(
                "pages.default.bilateralAgreements.input.startDate"
              )}
              dateFormat="dd.MM.yyyy"
              placement="bottom-end"
              max={objectionsHistoryFilter.endDate}
              value={objectionsHistoryFilter.startDate}
              onChange={startDateChange}
            />
            <Input
              type="date"
              placeholder={t("pages.default.bilateralAgreements.input.endDate")}
              dateFormat="dd.MM.yyyy"
              placement="bottom-end"
              min={objectionsHistoryFilter.startDate}
              value={objectionsHistoryFilter.endDate}
              onChange={endDateChange}
            />
            <Select
              defaultValue={objectionsHistoryFilter.status}
              options={[
                {
                  value: "-",
                  name: t("pages.default.certificates.filters.allStatus"),
                },
                { value: "ACCEPTED", name: translations.ACCEPTED },
                { value: "REJECTED", name: translations.REJECTED },
              ]}
              onChange={statusChange}
            />
            <Button
              type="primary"
              label={t("ui.default.filter")}
              onClick={getObjectionsHistory}
            />
            <Button
              type="secondary"
              label={t("ui.default.download")}
              suffixIcon="download"
              onClick={downloadCommitmentStatus}
              disabled={exportLoading}
              id="c-download"
            />
          </div>
        </div>
        <DataTableServerSideRendering
          columns={objectionsHistoryColumns}
          data={objectionsHistory}
          rowKey="id"
          sortedColumn={sortedColumn}
          setSortedColumn={setSortedColumn}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          pagination
          activePage={activePage}
          totalPageCount={objectTotal?.totalPageCount}
          handleFetchData={handleClick}
        />
      </div>
      {inspectedObjection && (
        <Modal isOpen={objectionJudgeModal} toggle={closeObjectionJudgeModal}>
          <div className="km__p--objection-modal-title">
            {t("pages.default.objections.evaluateObjection")}
            <div className="km__p--objection-modal-close">
              <Icon name="x" size="16" onClick={closeObjectionJudgeModal} />
            </div>
          </div>
          <div className="km__p--objection-modal-row">
            <div className="km__p--objection-modal-column">
              <TitleValue
                title={t("pages.default.objections.modal.organization")}
                value={inspectedObjection.organizationName}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userName")}
                value={inspectedObjection.userName}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderId")}
                value={inspectedObjection.orderId}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderDate")}
                value={inspectedObjection.orderTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchDate")}
                value={inspectedObjection.matchTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.objectionTime")}
                value={inspectedObjection.objectionTime}
                size="lg"
              />
            </div>
            <div className="km__p--objection-modal-column">
              <TitleValue
                title={t("pages.default.objections.modal.orderPrice")}
                value={`${convertNumberToFrontend({
                  num: inspectedObjection.orderPrice,
                  digit: 2,
                })} ₺`}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderAmount")}
                value={convertAmountToFrontend(inspectedObjection.orderAmount)}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchPrice")}
                value={`${convertNumberToFrontend({
                  num: inspectedObjection.matchPrice,
                  digit: 2,
                })} ₺`}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchAmount")}
                value={convertAmountToFrontend(
                  inspectedObjection.matchTotalAmount
                )}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userEmail")}
                value={inspectedObjection.userEmail}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userTel")}
                value={inspectedObjection.userTel}
                size="lg"
              />
            </div>
          </div>
          <div className="km__p--objection-modal-row">
            <Textarea
              label={t("pages.default.objections.modal.note")}
              defaultValue={inspectedObjection.details.note}
              disabled
            />
          </div>
          <div className="km__p--objection-modal-row">
            <Textarea
              label={t("pages.default.objections.modal.answer")}
              name="answer"
              value={objectionAnswer.answer}
              onChange={objectionAnswerChange}
            />
          </div>
          <div className="km__p--objection-modal-row">
            <Select
              label={t("pages.default.objections.modal.result")}
              name="objectionStatus"
              value={objectionAnswer.objectionStatus}
              options={[
                {
                  name: t("pages.default.objections.status.initial"),
                  value: "INITIAL",
                },
                {
                  name: t("pages.default.objections.status.accepted"),
                  value: "ACCEPTED",
                },
                {
                  name: t("pages.default.objections.status.rejected"),
                  value: "REJECTED",
                },
              ]}
              onChange={objectionAnswerChange}
            />
          </div>
          <div
            className="km__p--objection-modal-row"
            style={{ justifyContent: "flex-end" }}
          >
            <Button
              label={t("ui.default.discard")}
              type="destructive"
              onClick={closeObjectionJudgeModal}
            />
            <Button
              label={t("ui.default.save")}
              type="primary"
              onClick={judgeObjectionValidate}
            />
          </div>
        </Modal>
      )}
      {inspectedObjectionDetail && (
        <Modal isOpen={objectionDetailModal} toggle={closeObjectionDetailModal}>
          <div className="km__p--objection-modal-title">
            {t("pages.default.objections.viewObjection")}
            <div className="km__p--objection-modal-close">
              <Icon name="x" size="16" onClick={closeObjectionDetailModal} />
            </div>
          </div>
          <div className="km__p--objection-modal-row">
            <div className="km__p--objection-modal-column">
              <TitleValue
                title={t("pages.default.objections.modal.organization")}
                value={inspectedObjectionDetail.organizationName}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userName")}
                value={inspectedObjectionDetail.userName}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderId")}
                value={inspectedObjectionDetail.orderId}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderDate")}
                value={inspectedObjectionDetail.orderTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchDate")}
                value={inspectedObjectionDetail.matchTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.objectionTime")}
                value={inspectedObjectionDetail.objectionTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.answerBy")}
                value={inspectedObjectionDetail.answeredBy}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.answerTime")}
                value={inspectedObjectionDetail.answeredAt}
                size="lg"
              />
            </div>
            <div className="km__p--objection-modal-column">
              <TitleValue
                title={t("pages.default.objections.modal.orderPrice")}
                value={`${convertNumberToFrontend({
                  num: inspectedObjectionDetail.orderPrice,
                  digit: 2,
                })} ₺`}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderAmount")}
                value={convertAmountToFrontend(
                  inspectedObjectionDetail.quantityAdmin
                )}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchPrice")}
                value={`${convertNumberToFrontend({
                  num: inspectedObjectionDetail.matchPrice,
                  digit: 2,
                })} ₺`}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchAmount")}
                value={convertAmountToFrontend(
                  inspectedObjectionDetail.matchTotalAmount
                )}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userEmail")}
                value={inspectedObjectionDetail.userEmail}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userTel")}
                value={
                  inspectedObjectionDetail.details.userTel !== null
                    ? inspectedObjectionDetail.details.userTel
                    : "-"
                }
                size="lg"
              />
            </div>
          </div>
          <div className="km__p--objection-modal-row">
            <Textarea
              label={t("pages.default.objections.modal.note")}
              value={inspectedObjectionDetail.details.note}
              disabled
            />
          </div>
          <div className="km__p--objection-modal-row">
            <Textarea
              label={t("pages.default.objections.modal.answer")}
              name="answer"
              value={inspectedObjectionDetail.answer}
              disabled
            />
          </div>
          <div className="km__p--objection-modal-row">
            <Select
              label={t("pages.default.objections.modal.result")}
              name="objectionStatus"
              value={inspectedObjectionDetail.status}
              disabled
              options={[
                {
                  name: t("pages.default.objections.status.initial"),
                  value: "INITIAL",
                },
                {
                  name: t("pages.default.objections.status.accepted"),
                  value: "ACCEPTED",
                },
                {
                  name: t("pages.default.objections.status.rejected"),
                  value: "REJECTED",
                },
              ]}
            />
          </div>
        </Modal>
      )}
      {inspectedObjectionHistoryDetail && (
        <Modal
          isOpen={objectionHistoryDetailModal}
          toggle={closeObjectionHistoryDetailModal}
          className="km__p--objection-modal-history"
        >
          <div className="km__p--objection-modal-title">
            {t("pages.default.objections.viewObjection")}
            <div className="km__p--objection-modal-close">
              <Icon
                name="x"
                size="16"
                onClick={closeObjectionHistoryDetailModal}
              />
            </div>
          </div>
          <div className="km__p--objection-modal-row km__p--objection-modal-row-is-3col">
            <div className="km__p--objection-modal-column">
              <TitleValue
                title={t("pages.default.objections.modal.organization")}
                value={inspectedObjectionHistoryDetail.organizationName}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userName")}
                value={inspectedObjectionHistoryDetail.userName}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderId")}
                value={inspectedObjectionHistoryDetail.orderId}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderDate")}
                value={inspectedObjectionHistoryDetail.orderTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchDate")}
                value={inspectedObjectionHistoryDetail.matchTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.objectionTime")}
                value={inspectedObjectionHistoryDetail.objectionTime}
                size="lg"
              />
            </div>
            <div className="km__p--objection-modal-column">
              <TitleValue
                title={t("pages.default.objections.modal.orderPrice")}
                value={`${convertNumberToFrontend({
                  num: inspectedObjectionHistoryDetail.orderPrice,
                  digit: 2,
                })} ₺`}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderAmount")}
                value={convertAmountToFrontend(
                  inspectedObjectionHistoryDetail.quantityAdmin
                )}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchPrice")}
                value={`${convertNumberToFrontend({
                  num: inspectedObjectionHistoryDetail.matchPrice,
                  digit: 2,
                })} ₺`}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchAmount")}
                value={convertAmountToFrontend(
                  inspectedObjectionHistoryDetail.matchTotalAmount
                )}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userEmail")}
                value={inspectedObjectionHistoryDetail.userEmail}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userTel")}
                value={inspectedObjectionHistoryDetail.userTel}
                size="lg"
              />
            </div>
            <div className="km__p--objection-modal-column">
              <Textarea
                label={t("pages.default.objections.modal.note")}
                value={inspectedObjectionHistoryDetail.details.note}
                disabled
              />
            </div>
          </div>
          <MatchHistory
            exchangeOrderMatch={inspectedObjectionHistoryDetail}
            t={t}
          />
        </Modal>
      )}
      <ModalConfirmation
        header={t("pages.default.objections.confirmation.evaluate.title")}
        body={t("pages.default.objections.confirmation.evaluate.description")}
        toggle={() => setObjectionApproveModal(false)}
        isOpen={objectionApproveModal}
        approve={objectionAnswerRequest}
        loading={objectionAnswerLoading}
      />
    </>
  );
}
